<template>
  <div>
    <LTSHeader></LTSHeader>
    <div class="container">
      <div class="header-section">
        <div class="text-bold">Administrator: Firm Search</div>
        <div class="back-btn">
          <router-link class="btn-sm bg-primary text-white text-bold" to="/links">
            <img src="../assets/arrow-left.svg" alt /> Back
          </router-link>
        </div>
      </div>
      <div class="filters-section">
        <div class="pagination mb-1">
          <ul>
            <li @click="setAlphabetFilter('')">All</li>
            <li @click="setAlphabetFilter('A')">A</li>
            <li @click="setAlphabetFilter('B')">B</li>
            <li @click="setAlphabetFilter('C')">C</li>
            <li @click="setAlphabetFilter('D')">D</li>
            <li @click="setAlphabetFilter('E')">E</li>
            <li @click="setAlphabetFilter('F')">F</li>
            <li @click="setAlphabetFilter('G')">G</li>
            <li @click="setAlphabetFilter('H')">H</li>
            <li @click="setAlphabetFilter('I')">I</li>
            <li @click="setAlphabetFilter('J')">J</li>
            <li @click="setAlphabetFilter('K')">K</li>
            <li @click="setAlphabetFilter('L')">L</li>
            <li @click="setAlphabetFilter('M')">M</li>
            <li @click="setAlphabetFilter('N')">N</li>
            <li @click="setAlphabetFilter('O')">O</li>
            <li @click="setAlphabetFilter('P')">P</li>
            <li @click="setAlphabetFilter('Q')">Q</li>
            <li @click="setAlphabetFilter('R')">R</li>
            <li @click="setAlphabetFilter('S')">S</li>
            <li @click="setAlphabetFilter('T')">T</li>
            <li @click="setAlphabetFilter('U')">U</li>
            <li @click="setAlphabetFilter('V')">V</li>
            <li @click="setAlphabetFilter('W')">W</li>
            <li @click="setAlphabetFilter('X')">X</li>
            <li @click="setAlphabetFilter('Y')">Y</li>
            <li @click="setAlphabetFilter('Z')">Z</li>
          </ul>
        </div>
        <div>
          <label for="firmName">Firm Name</label>
          <input v-model="firmNameFilter" type="text" class="textbox" id="firmName" name="firmName" @input="search"/>
        </div>
      </div>
      <div class="firms-section mt-1">
        <Loader v-show="isSearching" class="loader"></Loader>
        <table>
          <tr>
            <th>Firm</th>
            <th>Database</th>
          </tr>
          <tr v-for="(firm, i) in filteredFirms" :key="i">
            <td>
              <router-link
                target="_blank"
                :to="{
                path: 'linkredirect',
                query: { applicationId: firm.applicationId, applicationUserId: firm.userProfileId }
              }"
              >{{firm.name}}</router-link>
            </td>
            <td>{{firm.db}}</td>
          </tr>
          <tr>
            <td colspan="2" v-show="filteredFirms.length == 0">
              No firms found...
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import LTSHeader from "@/components/LTSHeader";
import Loader from "@/components/Loader.vue";
import axios from "axios";

export default {
  components: {
    LTSHeader,
    Loader
  },
  data: function() {
    return {
      alphabetFilter: "",
      firmNameFilter: "",
      isSearching: false,
      firms: [],
      filteredFirms: []
    };
  },
  mounted() {
    axios
      .get("/firmsearch")
      .then(response => {
        this.firms = response.data;
        this.filteredFirms = response.data;
      })
      .catch(err => {
        this.error =
          "Could not load the firms list from the server. Please contact technical support.";
        console.log(err.response);
      });
  },
  // computed: {
  //   filteredFirms: function() {
  //     var filtered = this.firms;

  //     // Filter on the pagination alphabet
  //     if (this.alphabetFilter) {
  //       filtered = filtered.filter(f => {
  //         return this.StartsWithString(
  //           f.name.toUpperCase(),
  //           this.alphabetFilter
  //         );
  //       });
  //     }

  //     // filter on the typed name
  //     if (this.firmNameFilter) {
  //       filtered = filtered.filter(f => {
  //         return (
  //           f.name.toUpperCase().indexOf(this.firmNameFilter.toUpperCase()) > -1
  //         );
  //       });
  //     }

  //     // this.isSearching = false;
  //     return filtered;
  //   }
  // },
  methods: {
    search: function() {
      this.isSearching = true;
      var filtered = this.firms;

      // Filter on the pagination alphabet
      if (this.alphabetFilter) {
        filtered = filtered.filter(f => {
          return this.StartsWithString(
            f.name.toUpperCase(),
            this.alphabetFilter
          );
        });
      }

      // filter on the typed name
      if (this.firmNameFilter) {
        filtered = filtered.filter(f => {
          return (
            f.name.toUpperCase().indexOf(this.firmNameFilter.toUpperCase()) > -1
          );
        });
      }

      this.isSearching = false;
      this.filteredFirms = filtered;
    },
    setAlphabetFilter: function(val) {
      this.alphabetFilter = val;
      this.search();
    },
    StartsWithString: function(inputString, character) {
      //Check if "All filter" was selected, then character will be empty.
      if (character.length == 0) {
        return true;
      }

      if (inputString.length > 0) {
        var sw = inputString.toUpperCase().charAt(0);
        if (sw == character.toUpperCase()) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/* IMPORT VARIABLES */
@import "@/styles/_variables.scss";

.header-section {
  display: flex;
  justify-content: space-between;
  background: #f8f8ff;
  border: 1px solid $grey-color;
  padding: 0.5rem;
}

.back-btn {
  margin-left: auto;

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;

    img {
      padding-right: 5px;
    }
  }
}

.filters-section {
  display: flex;
  flex-direction: column;
  background: #f8f8ff;
  border: 1px solid $grey-color;
  padding: 0.5rem;
}

.pagination {
  ul {
    list-style-type: none;
  }

  li {
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    border-style: solid;
    border-width: 1px 0px 1px 1px;
    border-color: $grey-color;
    display: inline-block;
    padding: 3px 5px;

    &:hover {
      background: $primary-color;
      color: $white-color;
    }
  }

  li:first-child {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }

  li:last-child {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    border-right-width: 1px;
  }
}

.firms-section {
  table {
    width: 100%;
    background: #f8f8ff;
    border: 1px solid $grey-color;
    border-collapse: collapse;
    font-size: 0.8rem;

    tr:nth-child(odd) {
      background: #ededff;
    }

    th {
      text-align: left;
      padding: 0.8rem;
      font-weight: bold;
      background: $dark-blue-color;
      color: $white-color;
    }

    th:last-child {
      width: 30%;
    }

    td {
      padding: 0.2rem 0.8rem;
    }
  }
}

.loader {
    width: 4rem;
    margin: 0 auto;
  }
</style>